import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import { FrequentlyUsed } from 'emoji-mart'
import { useId, useRef } from 'react'
import { StackIcon } from 'shared/ui'

import type { Message } from '../../model/types'

import { api } from '../../api'
import { Label } from '../../const'
import { useCurrentId } from '../../hooks'
import css from './style.module.scss'

// @ts-ignore
const getByKey = (key: string) => data.emojis[key].skins[0].native

const previews = FrequentlyUsed.DEFAULTS.slice(0, 3).map(getByKey)

export function EmojiSelect({ message_id: message }: Message) {
	const [react, options] = api.useReactionMutation()
	const conversation = useCurrentId()
	const ref = useRef<HTMLDivElement | null>(null)
	const id = useId()

	function isNotReadyYet(emoji: string) {
		const isSameMessage = options.originalArgs?.message === message
		const isSameEmoji = options.originalArgs?.emoji === emoji

		return options.isLoading && isSameMessage && isSameEmoji
	}

	return (
		<>
			{previews.map(emoji => (
				<button
					className={`li-⚪ ${css.action}`}
					disabled={isNotReadyYet(emoji)}
					key={emoji}
					onClick={() => {
						react({
							conversation,
							emoji,
							mark: true,
							message
						})
					}}
					type='button'
				>
					<span className={css.quick}>{emoji}</span>
				</button>
			))}

			<button
				aria-label={Label.Emoji}
				className={`li-⚪ ${css.selectTrigger}`}
				// @ts-ignore
				popovertarget={id}
				popovertargetaction='toggle'
				title={Label.Emoji}
				type='button'
			>
				<StackIcon icon='emoji' stack='linkedin' width={18} />
			</button>

			<div
				className={css.selectMenu}
				id={id}
				// @ts-ignore Recheck in React 19
				popover='auto'
				ref={ref}
			>
				<Picker
					data={data}
					onEmojiSelect={({ native: emoji }: { native: string }) => {
						if (!isNotReadyYet(emoji)) {
							react({
								conversation,
								emoji,
								mark: true,
								message
							})
							ref.current?.hidePopover()
						}
					}}
				/>
			</div>
		</>
	)
}
